import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

export type BadgeTone = 'neutral' | 'success' | 'danger' | 'info' | 'warning'

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone
}

const toneClass: Record<BadgeTone, string> = {
  neutral: 'bg-slate-100 text-slate-700 border-slate-200',
  success:
    'bg-[color:var(--color-fitlab-green)]/10 text-[color:var(--color-fitlab-green-hover)] border-[color:var(--color-fitlab-green)]/30',
  danger:
    'bg-[color:var(--color-fitlab-red)]/10 text-[color:var(--color-fitlab-red-hover)] border-[color:var(--color-fitlab-red)]/30',
  info: 'bg-[color:var(--color-fitlab-blue)]/10 text-[color:var(--color-fitlab-blue)] border-[color:var(--color-fitlab-blue)]/30',
  warning: 'bg-amber-50 text-amber-900 border-amber-300',
}

export function Badge({ className, tone = 'neutral', ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium',
        toneClass[tone],
        className,
      )}
      {...rest}
    />
  )
}
